import "./HeaderTimer.css"
import { useDateTurno } from "src/pages/Cortes/home/hooks/useDateTurno"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { useTimePulse } from "src/shared/hooks/useTimePulse"

const HeaderTimer = () => {
    const { nombre } = useDateTurno()
    const { formatCustomDate } = useFormatDate()
    const [now] = useTimePulse()
    return (
        <div className="home-screen__turno__wrapper">
            <p className="home-screen__hora">{formatCustomDate(now, "MMM, DD, YYYY hh:mm A")}</p>
            <p className="home-screen__turno">Turno {nombre}</p>
        </div>
    )
}

export default HeaderTimer
